import { Event } from '../event';

export default class EventsEmitter {
  constructor() {
    this._events = {};
  }

  on(event, callback, ctx) {
    if (event in this._events === false) this._events[event] = new Event(event);
    return this._events[event].addListener(callback, ctx);
  }

  once(event, callback, ctx) {
    if (event in this._events === false) this._events[event] = new Event(event);
    return this._events[event].addListener(callback, ctx, true);
  }

  removeEvent(event) {
    delete this._events[event];
  }

  emit(event, ...args) {
    if (event in this._events) {
      this._events[event].callListeners(...args);
    }
  }

  removeAllEvents() {
    this._events = {};
  }

  hasEvent(event) {
    return event in this._events;
  }

  suspendAllEvents() {
    this._suspendedEvents = this._events;
    this._events = {};
  }

  returnSuspendedEvents() {
    this._events = this._suspendedEvents;
  }
}
